module.exports = __webpack_public_path__ + "static/media/shopee_white.554ea499.svg";